<app-status-badge
  [colourScheme]="statusBadgeColourSchemeEnum"
  name="ballot-status"
>
  {{ statusText }}
</app-status-badge>
